
import './App.css';
import Navbar from './layout/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from './pages/HomePage';
import Footer from './layout/Footer';
import ProjectPage from './pages/ProjectPage';
import JewelryExchange from "./pages/JewelryExcahnge";
import ExperiencePage from './pages/ExperiencePage';
import{BrowserRouter as Router, Routes, Route} from "react-router-dom"
import { useLocation } from 'react-router-dom';
import ThankYouPage from './pages/ThankYouPage';
import AboutPage from './pages/AboutPage';
import SocalFurs from './pages/Socalfurs';

function AppContent() {
  const location = useLocation();
  const hideNavbarAndFooter = location.pathname === '/1ljadsf234890xxnadklkjfasf23456' ||
  location.pathname === '/thank-you';

  return (
    <>
      {!hideNavbarAndFooter && <Navbar />}

      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/projects" element={<ProjectPage />} />
        <Route exact path="/experience" element={<ExperiencePage />} />
        <Route exact path="/1ljadsf234890xxnadklkjfasf23456" element={<JewelryExchange />} />
        <Route exact path="/thank-you" element={<ThankYouPage />} />
        <Route exact path="/about" element={<AboutPage />} />
        <Route exact path = "/socalfurs" element = {<SocalFurs/>}/>
      </Routes>

      {!hideNavbarAndFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;
